enum UserRole {
  VEREJNOST = 'VEREJNOST',
  PRIPOMIENKOVATEL = 'PRIPOMIENKOVATEL',
  VYHODNOCOVATEL = 'VYHODNOCOVATEL',
  ODOSIELATEL = 'ODOSIELATEL',
  SUPERADMIN = 'SUPERADMIN',
  NELEGISLATIVNA_ORGANIZACIA = 'NELEGISLATIVNA_ORGANIZACIA',
  PREDKLADATEL_LEG = 'PREDKLADATEL_LEG',
  PREDKLADATEL_NELEG = 'PREDKLADATEL_NELEG',
  PREDKLADATEL_ZODP= 'PREDKLADATEL_ZODP',
  AKTY_EU = 'AKTY_EU',
}

export default UserRole;
